<template>
  <div class="fob-entity" v-bind:class="{ 'compact-print-view': resourceSchema.compactPrintView}">
    <div class="columns">
      <div class="column" v-if="!loading && resourceData" :key="resourceId || -1">
        <div v-for="(bit, i) in displayFields" :key="i">
          <template v-if="bit.view === undefined || bit.view(resourceData, user, isPublic)">
            <div :class="bit.appendClass">
              <template v-if="bit.render === 'projektleiter'">
                <fob-projektleiter
                  :resourceData="resourceData[bit.field]"
                  :isPublic="isPublic"
                  :linkProvider="linkProvider"
                >
                </fob-projektleiter>
              </template>
              <template v-else-if="bit.render === 'embedded'">
                <div class="panel fobpanel">
                  <div class="panel-heading">
                    <translate>{{ bit.label }}</translate>
                  </div>
                  <div class="panel-block">
                    <fob-entity-value
                      style="width: 100%;"
                      :bit="bit"
                      :resourceData="resourceData[bit.field]"
                      :linkProvider="linkProvider"
                      :isPublic="isPublic"
                      :useCompactComponents="useCompactComponents"
                      :plain="bit.plain"
                      ></fob-entity-value>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="columns">
                  <div class="column column-key is-narrow has-text-weight-bold has-text-basalt"
                      style="width: 280px"
                  >
                    <translate>{{ bit.label }}</translate>
                    <div v-if="isPublic && bit.field === 'sdg'">
                      <a
                        :href="sdgPortalLink"
                        target="_blank"
                        style="font-size: 0.9em"
                        class="fob-hide-in-print"
                      >
                        <translate>ReadMore</translate>
                        <b-icon icon="external-link" size="is-small"></b-icon>
                      </a>
                    </div>
                  </div>
                  <div class="column column-value fix-flex-ms-column-width">
                    <!-- not pretty but we still need the label and thus can't hide the value -->
                    <template v-if="!isPublic || bit.field !== 'sdg'">
                      <fob-entity-value
                        :v-if="bit.type !== 'label'"
                        :bit="bit"
                        :resourceData="resourceData[bit.field]"
                        :linkProvider="linkProvider"
                        :isPublic="isPublic"
                        :useCompactComponents="useCompactComponents"
                        :plain="bit.plain"
                      ></fob-entity-value>
                    </template>
                    <!-- potentially, this could be moved to a schema option "iconRow", or similar -->
                    <div v-if="bit.field === 'sdg'">
                      <ul class="iconFlexRow">
                        <li v-for="(sdg, index) in resourceData[bit.field]" :key="index">
                          <b-tooltip :label="`SDG ${sdg._id}: ` + $gettext(`Sdg.SDG${sdg._id}`)" position="is-top">
                            <router-link :to="currentPublicRoute().withQuery({ sdg: `SDG${sdg._id}` })">
                              <img :src="sdgLink(sdg._id)" width="80">
                            </router-link>
                          </b-tooltip>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </template>

        </div>
      </div>
      <div class="column is-narrow"
        v-if="resourceData.logo != null && (resourceSchema.className === 'foerderung' || resourceSchema.className === 'mittelgeber') ">
        <img
          :src="resourceData.logo"
          :alt="`Logo ${resourceData._stringRep}`"
          style="margin: 4px 4px 4px 4px"
        >
      </div>
    </div>
  </div>
</template>

<script>
// import api from '@/api'
import { mapGetters } from 'vuex'
import entityValue from '@/components/EntityValue'
import DynamicTitle from '@/components/mixins/DynamicTitle'
import Projektleiter from '@/components/Projektleiter'
import PublicRouteBuilder from '@/components/mixins/PublicRouteBuilder'
import ExternalLinkProvider from '@/components/mixins/ExternalLinkProvider'

export default {
  name: 'fob-entity-details',
  components: {
    'fob-entity-value': entityValue,
    'fob-projektleiter': Projektleiter,
  },
  mixins: [
    DynamicTitle,
    ExternalLinkProvider,
    PublicRouteBuilder,
  ],
  created () {
    // some schema fields have computed properties
    // e.g. creating links from pubIdent values
    // at first filter those items with "computed" function ...
    let schema = this.resourceSchema.fields.filter((bit) => {
      return bit.computed
    })
    // ... then use their "computed" function to calculate new values
    // and append them to resourceData.
    schema.forEach((bit) => {
      let data = bit.computed(this.resourceData)
      this.resourceData[bit.field] = data
    })
  },
  data () {
    return {
      leurisHead: {
        inner: this.isPublic ? 'leuris:Portal' : 'leuris:Forschungsbericht',
        complement: 'menu.details'
      }
    }
  },
  props: [
    'resourceSchema',
    'resourceData',
    'resourceId',
    'linkProvider',
    'useCompactComponents',
    'isPublic'
  ],
  computed: {
    ...mapGetters({
      loading: 'resource/isLoading',
      user: 'user/getUser',
    }),
    displayFields () {
      if (this.isPublic) {
        return this.resourceSchema.fields.filter(x => x.inPublicView !== false)
      } else {
        return this.resourceSchema.fields
      }
    }
  },
  methods: {
    sdgLink (id) {
      let lpad = `0${id}`.slice(-2)
      return `/static/sdg/E_WEB_${lpad}.png`
    }
  }
}
</script>

<style scoped>
  li {
    margin-bottom: 10px;
  }

  .fobpanel {
    margin-top: 10px;
    margin-bottom: 10px;
    background: white;
  }

  .fix-flex-ms-column-width {
    flex: auto;
  }

  .iconFlexRow {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 10px;
    row-gap: 10px;
  }

  .iconFlexRow li {
    margin: 0;
    padding: 0;
  }

  /*
    the tooltip produces an extra wrapper span which has some extra space
    for descenders, `display: block` removes this extra space
  */
  .iconFlexRow li span {
    display: block;
  }

  .iconFlexRow li img {
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/EntityDetails.vue